import classNames from "classnames";
import { FieldState } from "formstate";
import { observer } from "mobx-react";
import React from "react";
import { EditInputFieldState } from "@fidget/common/components/form/editInput";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "../../proactiveMessagesList.css";
import taggingStyles from "../../../tags/taggingSettings/taggingSettings.css";
import { staticConfig } from "@fidget/common/config/static-config";

interface Props {
  field: FieldState<string>;
  isEdited: boolean;
}
export const FormMessage = observer(({ field, isEdited }: Props) => {
  const renderFormMessage = () => {
    if (isEdited) {
      return (
        <EditInputFieldState
          className={classNames(taggingStyles["bottom-input"])}
          field={field}
          readOnly={!isEdited}
          placeholder={intl.formatMessage("settings.proactiveMessage.addNew.message.placeholder", {
            limit: staticConfig.proactiveMessageMaxCharacters
          })}
          maxLength={staticConfig.proactiveMessageMaxCharacters}
        />
      );
    }

    return (
      <p
        className={classNames(
          styles["form-text"],
          styles["message-margin"],
          styles["form-message-text"]
        )}
      >
        {field.$}
      </p>
    );
  };

  return (
    <div className={classNames(styles["input-container"], styles["message-input"])}>
      <div className={classNames(styles["form-text"], styles["form-text-dimmed"])}>
        <L10n id={"settings.proactiveMessage.addNew.message.title"} />
      </div>
      {renderFormMessage()}
    </div>
  );
});
